export enum UserActionType {
    UPDATE_PRICE = "UPDATE_PRICE",
    CONFIRM_PRICE = "CONFIRM_PRICE",
    NEW_FUEL_TYPE = "NEW_FUEL_TYPE",
}